import { render, staticRenderFns } from "./PostCategories.vue?vue&type=template&id=c9fc4820&scoped=true"
import script from "./PostCategories.vue?vue&type=script&lang=js"
export * from "./PostCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fc4820",
  null
  
)

export default component.exports